/**
 * Tiny className joiner. Avoids pulling in clsx/tailwind-merge for a handful
 * of components. Falsy values are dropped so callers can do
 *   cn("base", isActive && "active", maybeClass)
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}
